import React, { useState } from 'react';
import { Container, Form, Button, Alert } from 'react-bootstrap';
import AboutHero from '../components/common/AboutHero';
import Recete3 from '../assets/images/recete3.jpg';
import { toUrl } from '../lib/config';

const YatanHastaAnketPage: React.FC = () => {
  const [formData, setFormData] = useState({
    cinsiyet: 'Kadın',
    yasKategorisi: '20-29',
    egitimDurumu: 'İlkokul',
    hastaOdasiVeCevresinde: 'Evet',
    odadakiEsyalar: 'Evet',
    yemekSaglayan: 'Evet',
    yemeklerinSicakligi: 'Evet',
    doktorumTarafindanHastaligim: 'Evet',
    hemsireleTarafindanTedavi: 'Evet',
    doktorumBanaKarsi: 'Evet',
    hemsirelernBanaKarsi: 'Evet',
    temizlikPersoneli: 'Evet',
    hastaneCalisaninin: 'Evet',
    hastanePoliklinikleri: 'Evet',
    hastaligimIleIlgili: 'Evet',
    hastaneVerilen: 'Evet',
    hastanedenAyrilirken: 'Evet',
    gorusVeOnerileriniz: ''
  });

  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    try {
      setLoading(true);
      setError('');
      setSuccess(false);

      const url = toUrl('/api/yatan-hasta-anket');
      const response = await fetch(url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error('Anket gönderilemedi. Lütfen tekrar deneyin.');
      }

      setSuccess(true);
      // Formu varsayılan değerlere sıfırla
      setFormData({
        cinsiyet: 'Kadın',
        yasKategorisi: '20-29',
        egitimDurumu: 'İlkokul',
        hastaOdasiVeCevresinde: 'Evet',
        odadakiEsyalar: 'Evet',
        yemekSaglayan: 'Evet',
        yemeklerinSicakligi: 'Evet',
        doktorumTarafindanHastaligim: 'Evet',
        hemsireleTarafindanTedavi: 'Evet',
        doktorumBanaKarsi: 'Evet',
        hemsirelernBanaKarsi: 'Evet',
        temizlikPersoneli: 'Evet',
        hastaneCalisaninin: 'Evet',
        hastanePoliklinikleri: 'Evet',
        hastaligimIleIlgili: 'Evet',
        hastaneVerilen: 'Evet',
        hastanedenAyrilirken: 'Evet',
        gorusVeOnerileriniz: ''
      });

      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch (err: any) {
      setError(err.message || 'Bir hata oluştu. Lütfen tekrar deneyin.');
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement | HTMLTextAreaElement | HTMLInputElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  return (
    <>
      <AboutHero
        image={Recete3}
        kicker="Bize ulaşın"
        title="İletişim"
        description="Megapark Hastanesi her an ve her zaman sizin yanınızda"
        overlayColor="#2cadd2"
        overlayOpacity={0.72}
        accentColor="#e30613"
        textColor="#ffffff"
        focus="center center"
        align="center"
        desktopHeight={460}
        tabletHeight={380}
        mobileHeight={320}
      />
      <section className="py-5 bg-light">
      <Container>
        <div className="bg-white rounded shadow-sm p-4 p-md-5">
          {/* Header */}
          <div className="mb-4">
            <h1 className="h3 mb-3">
              Yatan Hasta <span style={{ color: '#f44336' }}>Memnuyet Anketi</span>
            </h1>
            <p className="text-muted mb-3">
              Aşağıda yer alan soruları gerçekçi bir şekilde yanıtlamanız, kaliteli hizmet sunmayı hedefleyen hastanemiz için
              büyük bir önem taşımaktadır. Sizden beklenen, verilen cümleler konusundaki kanaatinizi Evet, Biraz/Kısmen
              ve Hayır ifadelerini arasından size en yakın gelen seçeneği işaretlemek suretiyle belirtmenizdir. Bu konuda göstermiş
              olduğunuz ilgi ve yardımlarınızdan dolayı şimdiden teşekkür eder, geçmiş olsun dileklerimizi iletriz.
            </p>
            <p className="fw-bold mb-2">Kurum Yöneticisi</p>
            <p className="small text-muted">
              Not: Kişisel bilgileriniz ve ankette verdiğiniz bilgileri kesinlikle gizli tutulacaktır.
            </p>
          </div>

          {/* Başarı Mesajı */}
          {success && (
            <Alert variant="success" onClose={() => setSuccess(false)} dismissible>
              <Alert.Heading>Teşekkür Ederiz!</Alert.Heading>
              <p>
                Anketiniz başarıyla gönderildi. Görüşleriniz bizim için çok değerli.
              </p>
            </Alert>
          )}

          {/* Hata Mesajı */}
          {error && (
            <Alert variant="danger" onClose={() => setError('')} dismissible>
              <Alert.Heading>Hata!</Alert.Heading>
              <p>{error}</p>
            </Alert>
          )}

          {/* Form */}
          <Form onSubmit={handleSubmit}>
            {/* Cinsiyetiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Cinsiyetiniz</Form.Label>
              <Form.Select
                name="cinsiyet"
                value={formData.cinsiyet}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Kadın</option>
                <option value="erkek">Erkek</option>
              </Form.Select>
            </Form.Group>

            {/* Ait Olduğunuz Yaş Kategorisini Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Ait Olduğunuz Yaş Kategorisini Belirtiniz</Form.Label>
              <Form.Select
                name="yasKategorisi"
                value={formData.yasKategorisi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="20-29">20-29</option>
                <option value="30-39">30-39</option>
                <option value="40-49">40-49</option>
                <option value="50-59">50-59</option>
                <option value="60+">60+</option>
              </Form.Select>
            </Form.Group>

            {/* Eğitim Durumunuzu Belirtiniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">Eğitim Durumunuzu Belirtiniz</Form.Label>
              <Form.Select
                name="egitimDurumu"
                value={formData.egitimDurumu}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Okur-yazar değil</option>
                <option value="ilkokul">İlkokul</option>
                <option value="ortaokul">Ortaokul</option>
                <option value="lise">Lise</option>
                <option value="universite">Üniversite</option>
              </Form.Select>
            </Form.Group>

            {/* Anket Soruları */}
            <div className="mt-5 mb-4">
              <h4 className="h5 fw-bold">Anket Soruları</h4>
            </div>

            {/* Soru 1 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                1.Hasta odası ve çevresinde genel olarak sessiz ve sakin bir ortam sağlanmıştır.
              </Form.Label>
              <Form.Select
                name="hastaOdasiVeCevresinde"
                value={formData.hastaOdasiVeCevresinde}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 2 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                2.Odadaki eşyalar çalışır durumdaydı. (televizyon, hemşire çağrı zili, lamba, yatak vb.)
              </Form.Label>
              <Form.Select
                name="odadakiEsyalar"
                value={formData.odadakiEsyalar}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 3 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                3.Yemek sağlayan personel hijyen kurallarına uygun davrandı.(bone, eldiven, maske gibi koruyucu ekipman kullanıldı)
              </Form.Label>
              <Form.Select
                name="yemekSaglayan"
                value={formData.yemekSaglayan}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 4 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                4.Yemeklerin sıcaklığı uygundu.
              </Form.Label>
              <Form.Select
                name="yemeklerinSicakligi"
                value={formData.yemeklerinSicakligi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 5 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                5.Doktorum tarafından hastalığım hakkında bana bilgi verildi.
              </Form.Label>
              <Form.Select
                name="doktorumTarafindanHastaligim"
                value={formData.doktorumTarafindanHastaligim}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 6 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                6.Hemşireler tarafından tedavi ve bakımıma ilgili bana bilgi verildi.
              </Form.Label>
              <Form.Select
                name="hemsireleTarafindanTedavi"
                value={formData.hemsireleTarafindanTedavi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 7 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                7.Doktorum bana karşı ilgiliydi.
              </Form.Label>
              <Form.Select
                name="doktorumBanaKarsi"
                value={formData.doktorumBanaKarsi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 8 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                8.Hemşirelern bana karşı ilgiliydi.
              </Form.Label>
              <Form.Select
                name="hemsirelernBanaKarsi"
                value={formData.hemsirelernBanaKarsi}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 9 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                9.Temizlik personeli bana karşı ilgiliydi.
              </Form.Label>
              <Form.Select
                name="temizlikPersoneli"
                value={formData.temizlikPersoneli}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 10 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                10.Hastane çalışanının kişisel mahremiyetime (muayene edilirken kapının kapatılması, aralıklı perde ya da paravanın çekilmesi gibi) özen gösterdi.
              </Form.Label>
              <Form.Select
                name="hastaneCalisaninin"
                value={formData.hastaneCalisaninin}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 11 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                11.Hastane (poliklinikler, muayene olduğunuz oda, bekleme alanları, tuvaletler) genel olarak temizdi.
              </Form.Label>
              <Form.Select
                name="hastanePoliklinikleri"
                value={formData.hastanePoliklinikleri}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 12 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                12.Hastalığım ile ilgili ihtiyaç duyduğum durumda doktoruma ulaşabildim.
              </Form.Label>
              <Form.Select
                name="hastaligimIleIlgili"
                value={formData.hastaligimIleIlgili}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 13 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                13.Hastane verilen hizmet genel olarak iyiydi.
              </Form.Label>
              <Form.Select
                name="hastaneVerilen"
                value={formData.hastaneVerilen}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Soru 14 */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                14.Hastaneden ayrılırken taburculuk sonrası süreçte ilgili bana bilgi verildi.
              </Form.Label>
              <Form.Select
                name="hastanedenAyrilirken"
                value={formData.hastanedenAyrilirken}
                onChange={handleChange}
                required
                className="form-select-lg"
              >
                <option value="">Evet</option>
                <option value="biraz">Biraz</option>
                <option value="hayir">Hayır</option>
              </Form.Select>
            </Form.Group>

            {/* Görüş ve Önerileriniz */}
            <Form.Group className="mb-4">
              <Form.Label className="fw-semibold">
                Varsa görüş ve önerileriniz:
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={5}
                name="gorusVeOnerileriniz"
                value={formData.gorusVeOnerileriniz}
                onChange={handleChange}
                placeholder="Görüş ve önerilerinizi buraya yazabilirsiniz..."
                className="form-control-lg"
              />
            </Form.Group>

            {/* Submit Button */}
            <div className="d-grid gap-2 mt-5">
              <Button
                type="button"
                size="lg"
                disabled={loading}
                onClick={(e) => {
                  handleSubmit(e as any);
                }}
                style={{
                  backgroundColor: '#2cadd2',
                  borderColor: '#2cadd2',
                  fontWeight: '600'
                }}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Gönderiliyor...
                  </>
                ) : (
                  'Anketi Gönder'
                )}
              </Button>
            </div>
          </Form>
        </div>
      </Container>
    </section>
    </>
  );
};

export default YatanHastaAnketPage;
